import { RouterProvider } from 'react-router-dom';
import { Toaster, TooltipProvider } from '@prenuvo/halo-foundation';
import { QueryClientProvider } from '@tanstack/react-query';

import { dataDogLogger } from '@/core/data-dog';
import { setupPdfWorker } from '@/core/pdf-worker';
import { queryClient } from '@/core/react-query';
import { ReportIssueProvider } from '@/core/report-issue';
import { ThemeProvider } from '@/core/theme';
import { UserState } from '@/core/user';
import { ROUTES } from '@/routes';

export function App() {
  dataDogLogger.debug('Starting application');

  setupPdfWorker();

  return (
    <ThemeProvider defaultTheme="dark">
      <Toaster>
        <TooltipProvider>
          <QueryClientProvider client={queryClient}>
            <UserState>
              <ReportIssueProvider>
                <RouterProvider router={ROUTES} />
              </ReportIssueProvider>
            </UserState>
          </QueryClientProvider>
        </TooltipProvider>
      </Toaster>
    </ThemeProvider>
  );
}
